module.exports = __webpack_public_path__ + "img/code_three.aadb38d2.png";